<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Data Table</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model.lazy="searchText"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div v-show="isFetched">
              <div class="table-responsive mb-0">
                <vue-good-table
                    mode="remote"
                    :pagination-options="{
                      enabled: false,
                      mode: 'pages',
                      perPage: perPage,
                      position: 'bottom',
                      perPageDropdown: [5, 10],
                      dropdownAllowAll: false,
                      nextLabel: 'next',
                      prevLabel: 'prev',
                      rowsPerPageLabel: 'Rows per page',
                      ofLabel: 'of',
                      pageLabel: 'page', // for 'pages' mode
                      allLabel: 'All',
                    }"
                    :totalRows="totalRows"
                    :rows="productData"
                    :columns="columns"
                    :sort-options="{
                      enabled: false,
                    }"
                    :row-style-class="rowStyleClassFn"
                >
                  <template slot="table-row" slot-scope="props">
                    <div v-if="props.column.field == 'btn'">
                      <b-button pill variant="primary" size="sm" v-b-modal.modal-1 @click="viewRelungku(props.row.id)">Lihat</b-button>
                    </div>
                    <div v-else-if="props.column.field === 'status'">
                      <b-badge variant="success" v-if="props.row.status === 'active'">Aktif</b-badge>
                      <b-badge variant="warning" v-else-if="props.row.status === 'checking_process'">Perlu Cek</b-badge>
                      <b-badge variant="danger" v-else>Ditolak</b-badge>
                    </div>
                  </template>
                </vue-good-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from 'axios';
export default {
  name: "relungku",
  page: {
    title: "Relungku",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader},
  created() {
    this.fetchAccountData()
  },
  data() {
    return {
      title: "Relungku",
      items: [
        {
          text: "Tables",
          href: "/"
        },
        {
          text: "Advanced",
          active: true
        }
      ],
      totalRows: 1,
      searchText: '',
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      isFetched: false,
      getArguments: {
        limit: 11,
        page: 1,
        sort: '-id',
        product_name: '',
        relungku: 'true',
      },
      productData: [],
      columns: [
        { field: "id", label: "ID" },
        { field: "account_name", label: "Nama Sumber" },
        { field: "account_email", label: "Email Sumber" },
        { field: "product_type", label: "Type Produk" },
        { field: "product_name", label: "Nama" },
        { field: "price", label: "Harga" },
        { field: "status", label: "Status" },
        { field: "btn", label: "#" },
      ],
    }
  },
  computed: {


  },
  methods: {
    rowStyleClassFn() {
      return 'default'
    },
    fetchAccountData() {
      let params = queryString.stringify({
        ...{
          product_name: null,
          sort: '-id',
          relungku: 'true',
        }
        , ...this.getArguments}
      )
      this.httpCallProductData(params)
    },
    httpCallProductData(params) {
      axios.get("/api/product?"+params)
          .then(resp => {
            const { data, pagination } = resp.data
            this.totalRows = pagination.total
            this.productData = data
            this.isFetched = true
          });
    },
    viewRelungku(relungkuID){
      this.$router.push('/relungku/view/'+relungkuID)
    },
  },
  watch: {
    searchText: function(value){
      this.currentPage = 1
      let params = queryString.stringify({
        limit: this.perPage,
        page: this.currentPage,
        product_name: value,
        sort: '-id',
        relungku: 'true',
      })
      this.httpCallProductData(params)
    },
    perPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1
        let params = queryString.stringify({
          limit: newValue,
          page: this.currentPage,
          product_name: this.searchText,
          sort: '-id',
          relungku: 'true',
        })
        this.httpCallProductData(params)
      }
    },
    currentPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        let params = queryString.stringify({
          limit: this.perPage,
          page: newValue,
          product_name: this.searchText,
          sort: '-id',
          relungku: 'true',
        })
        this.httpCallProductData(params)
      }
    },
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>